import { ToastProvider } from './module/shop/components/toast/ToastProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import { I18nProvider } from '@fluxora/i18n';
import { ThemeProvider } from '@fluxora/theme';

import { createQueryClient } from './config/queryClient';
import { shopResources } from './config/i18n';
import { router } from './router';

const queryClient = createQueryClient();

/**
 * US-Shop app shell. Public, anonymous — no auth provider, no tenant context in
 * the browser. Just query cache + theme tokens + i18n + the router.
 */
export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider country="US" defaultTheme="light">
        <I18nProvider locale="en-US" resources={shopResources}>
          <ToastProvider>
          <RouterProvider router={router} />
          </ToastProvider>
        </I18nProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
